import { animate, state, style, transition, trigger } from '@angular/animations';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Output, WritableSignal, inject, signal } from '@angular/core';
import { Module, ModuleType } from '@enliven/angular';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { SignOutOpts } from 'src/app/models/sign-out-opts.model';
import { E360SessionService } from 'src/app/services/e360-session.service';
import { E360UserService } from 'src/app/services/e360-user.service';
import { HeaderService } from 'src/app/services/header.service';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'e360-left-nav',
  templateUrl: './left-nav.component.html',
  styleUrls: ['./left-nav.component.scss'],
  animations: [
    trigger('toggleSideNav', [
      state('nav-expanded', style({ width: '240px' })),
      state('nav-collapsed', style({ width: '88px' })),
      transition('nav-expanded <=> nav-collapsed', animate('200ms'))
    ])
  ],
  standalone: true,
  imports: [NgTemplateOutlet, TranslateModule, NgClass, NgbTooltipModule, NgbDropdownModule]
})
export class LeftNavComponent {
  @Output() appClick: EventEmitter<Module> = new EventEmitter();
  @Output() signOut: EventEmitter<SignOutOpts> = new EventEmitter();

  navigationService: NavigationService = inject(NavigationService);
  e360UserService: E360UserService = inject(E360UserService);
  headerService: HeaderService = inject(HeaderService);
  e360SessionService: E360SessionService = inject(E360SessionService);

  readonly EMBEDDED: ModuleType = ModuleType.EMBEDDED;

  sideMenuIsExpanded: WritableSignal<boolean> = signal(true);

  handleSideMenuToggle() {
    this.sideMenuIsExpanded.set(!this.sideMenuIsExpanded());
  }

  logout() {
    this.signOut.emit({ message: 'ALERT_PAGE.YOU_HAVE_BEEN_SIGNED_OUT', displaySignInLink: true });
  }
}
